<mat-menu #menuItem="matMenu">
  <ng-container *ngFor="let item of items">
    <button mat-menu-item
            *ngIf="!item.children; else branch"
            (click)="onItemSelect(item)"
            [attr.data-automation-id]="'bc-hierarchy-dropdown-item'">{{ item.text }}</button>
    <ng-template #branch>
      <button mat-menu-item [matMenuTriggerFor]="innerPanel.menu" (click)="onItemSelect(item)">{{ item.text }}</button>
      <app-hierarchy-dropdown-sub-menu #innerPanel
                                       [items]="item.children" (onSubItemSelected)="onItemSelect($event)">
      </app-hierarchy-dropdown-sub-menu>
    </ng-template>
  </ng-container>
</mat-menu>
